<script>
import InfoBlock from '@components/info-block.vue'
import { getSecurityInfo, submitChangePasswordForm, submitChangeSecurityQuestionForm } from '@src/api/security'
import _ from 'lodash'
import { authComputed } from '@state/helpers'
import { submitSaveNotificationsForm } from '@src/api/emailNotifications'

export default {
  components: {
    InfoBlock,
  },
  data() {
    return {
      recoveryQuestions: '',
      password: '',
      newPassword: '',
      confirmNewPassword: '',
      recoveryQuestion: '',
      originalRecoveryQuestion: '',
      recoveryAnswer: '',
      emailNotificationReferral: [0],
      initialLoading: true,
      loadingChangePassword: false,
      loadingChangeSecurityQuestion: false,
      loadingSaveNotifications: false,
      successfully: false,
      isEmptyPassword: false,
      isWrongPassword: false,
      isWrongConfirmNewPassword: false,
      isWrongRecoveryAnswer: false,
    }
  },
  computed: {
    ...authComputed,
    labels() {
      return {
        password: 'Current Password',
        newPassword: 'New Password',
        confirmNewPassword: 'Confirm New Password',
        recoveryQuestion: 'Security Question',
        recoveryAnswer: 'Security Question Answer',
      }
    },

    placeholders() {
      return {
        password: 'Your password',
        newPassword: 'Your new password',
        confirmNewPassword: 'Confirm your new password',
        recoveryAnswer: 'Your answer',
      }
    },

    showNotificationsSection() {
      return this.canManageNetworkConnect && !this.hasUserProfileFeature
    },

    canPressChangePasswordButton() {
      if (!this.newPassword || !this.confirmNewPassword) {
        return false
      }
      return !this.loadingChangePassword && !this.loadingChangeSecurityQuestion
    },

    canPressChangeSecurityQuestionButton() {
      if (!this.recoveryQuestion || !this.recoveryAnswer) {
        return false
      }
      return !this.loadingChangePassword && !this.loadingChangeSecurityQuestion
    },

    canPressSaveNotificationsButton() {
      return !this.loadingSaveNotifications
    },

    confirmPasswordInvalid() {
      return this.newPassword !== this.confirmNewPassword
    },
  },
  mounted() {
    this.getSecurityInfo()
  },
  methods: {
    async getSecurityInfo() {
      this.authError = null
      try {
        await getSecurityInfo().then((result) => {
          this.recoveryQuestion = result.data.data.selectedQuestion
          this.originalRecoveryQuestion = result.data.data.selectedQuestion
          this.recoveryQuestions = result.data.data.allRecoveryQuestions
          this.emailNotificationReferral[0] = result.data.data.emailNotifications.referral.toString()
          this.initialLoading = false
        })
      } catch (err) {
        this.authError = _.get(err, 'response.data.data', 'Server Error. Please try again in a few moments.')
        this.initialLoading = false
        this.successfully = true
        this.toastLoadError()
      }
    },

    async submitChangePasswordForm() {
      this.authError = null
      this.isEmptyPassword = false
      this.isWrongPassword = false
      this.isWrongConfirmNewPassword = false
      if (!this.password) {
        this.isEmptyPassword = true
        return
      }
      if (this.confirmPasswordInvalid) {
        this.isWrongConfirmNewPassword = true
        return
      }
      this.loadingChangePassword = true
      try {
        await submitChangePasswordForm({
          oldPassword: this.password,
          newPassword: this.newPassword,
        }).then((res) => {
          this.password = ''
          this.newPassword = ''
          this.confirmNewPassword = ''
          this.toastSuccess('You have successfully changed your password.')
          this.$store.commit('user/SET_CURRENT_USER', res.data)
          this.loadingChangePassword = false
        })
      } catch (err) {
        this.loadingChangePassword = false
        this.authError = _.get(err, 'response.data.data', 'Server Error. Please try again in a few moments.')
        if (typeof this.authError === 'object') {
          if (typeof this.authError.password === 'object') {
            this.authError = this.authError.password.join(' ')
          }
          if (typeof this.authError.newPassword === 'object') {
            this.authError = this.authError.newPassword.join(' ')
          }
        }
        if (typeof this.authError === 'string') {
          if (this.authError.indexOf('recoveryQuestion.answer:') > 0) {
            this.authError = 'The answer to the recovery question is incorrect. Please try again.'
          }
          this.authError = this.authError.replace('Okta Error: password.value: ', '')
          this.authError = this.authError.replace('Okta Error: ', '')
          if (this.authError.indexOf('Old Password is not correct') !== -1) {
            this.isWrongPassword = true
            return
          }
        }
        this.toastError()
      }
    },

    async submitChangeSecurityQuestionForm() {
      this.authError = null
      this.isEmptyPassword = false
      this.isWrongPassword = false
      this.isWrongRecoveryAnswer = false
      if (!this.password) {
        this.isEmptyPassword = true
        return
      }
      if (this.recoveryAnswer.length < 4) {
        this.isWrongRecoveryAnswer = true
        return
      }
      this.loadingChangeSecurityQuestion = true
      try {
        await submitChangeSecurityQuestionForm({
          password: this.password,
          recoveryQuestion: this.recoveryQuestion,
          recoveryAnswer: this.recoveryAnswer,
        }).then(() => {
          this.password = ''
          this.recoveryAnswer = ''
          this.originalRecoveryQuestion = this.recoveryQuestion
          this.toastSuccess('You have successfully updated your security question.')
          this.loadingChangeSecurityQuestion = false
        })
      } catch (err) {
        this.authError = _.get(err, 'response.data.data', 'Server Error. Please try again in a few moments.')
        if (typeof this.authError === 'object') {
          if (typeof this.authError.password === 'object') {
            this.authError = this.authError.password.join(' ')
          }
        }
        if (this.authError.indexOf('recoveryQuestion.answer:') > 0) {
          this.authError = 'The answer to the recovery question is incorrect. Please try again.'
        }
        this.authError = this.authError.replace('Okta Error: password.value: ', '')
        this.authError = this.authError.replace('Okta Error: ', '')
        this.loadingChangeSecurityQuestion = false
        if (this.authError.indexOf('Invalid username/password combination') !== -1) {
          this.isWrongPassword = true
          return
        }
        this.toastError()
      }
    },

    async submitSaveNotificationsForm() {
      this.authError = null
      this.loadingSaveNotifications = true
      try {
        await submitSaveNotificationsForm({
          emailNotifications: { referral: this.emailNotificationReferral[0] ? 1 : 0 },
        }).then(() => {
          this.toastSuccess('You have successfully updated your notification preferences.')
          this.loadingSaveNotifications = false
        })
      } catch (err) {
        this.authError = _.get(err, 'response.data.data', 'Server Error. Please try again in a few moments.')
        this.loadingSaveNotifications = false
        this.toastError()
      }
    },

    toastLoadError() {
      this.$bvToast.toast(this.authError, {
        toaster: 'b-toaster-bottom-center',
        toastClass: 'toast-error',
        noAutoHide: true,
      })
    },

    toastError() {
      this.$bvToast.toast(this.authError, {
        toaster: 'b-toaster-bottom-center',
        toastClass: 'toast-error',
      })
    },

    toastSuccess(toastMessage) {
      this.$bvToast.toast(toastMessage, {
        toaster: 'b-toaster-bottom-center',
        toastClass: 'toast-success',
      })
    },
  },
}
</script>

<template>
  <div :class="$style.viewContainer">
    <BaseIcon v-if="initialLoading" name="spinner" spin />
    <div v-else-if="!successfully">
      <div class="mt-40">
        <BaseTitle :class="$style.title">Security</BaseTitle>
      </div>
      <InfoBlock class="mb-4">
        Current Password is required to Change Password or Change Security Question/Answer
      </InfoBlock>

      <div class="row">
        <div class="col-lg-6">
          <form>
            <BaseFormGroup :label="labels.password">
              <BaseInputPassword
                v-model="password"
                name="password"
                :changed="password !== ''"
                :error="
                  isEmptyPassword
                    ? 'The current password is required.'
                    : isWrongPassword
                    ? 'The current password is incorrect. Try again.'
                    : ''
                "
                :placeholder="placeholders.password" />
            </BaseFormGroup>
          </form>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <hr :class="$style.hr" />
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6">
          <form class="px-0" @submit.prevent="submitChangePasswordForm">
            <h3 :class="$style.h3">Change my Password</h3>

            <BaseFormGroup :label="labels.newPassword" class="mb-40">
              <BaseInputPassword
                v-model="newPassword"
                :changed="newPassword !== ''"
                name="newPassword"
                :placeholder="placeholders.newPassword" />
            </BaseFormGroup>

            <BaseFormGroup :label="labels.confirmNewPassword" class="mb-40">
              <BaseInputPassword
                v-model="confirmNewPassword"
                name="confirmNewPassword"
                :changed="confirmNewPassword !== ''"
                :error="isWrongConfirmNewPassword ? 'The passwords don’t match.' : ''"
                :placeholder="placeholders.confirmNewPassword" />
            </BaseFormGroup>

            <div :class="$style.divButton">
              <BaseButton :class="$style.button" :disabled="!canPressChangePasswordButton" type="submit">
                <BaseIcon v-if="loadingChangePassword" name="spinner" spin />
                <span v-else>Change Password</span>
              </BaseButton>
            </div>
          </form>
        </div>

        <div class="col-md-12" :class="$style.showMobile">
          <hr :class="$style.hr" />
        </div>

        <div class="col-lg-6">
          <form class="px-0" @submit.prevent="submitChangeSecurityQuestionForm">
            <h3 :class="$style.h3">Change my Security Question</h3>

            <BaseFormGroup :label="labels.recoveryQuestion" class="mb-40">
              <BaseSelect
                v-model="recoveryQuestion"
                name="recoveryQuestion"
                empty-text="-- Select a Security Question --"
                :options="recoveryQuestions"
                :changed="recoveryQuestion !== originalRecoveryQuestion"
                option-text="questionText"
                option-value="questionText" />
            </BaseFormGroup>

            <BaseFormGroup :label="labels.recoveryAnswer" class="mb-40">
              <BaseInputText
                v-model="recoveryAnswer"
                autocomplete="off"
                name="recoveryAnswer"
                :changed="recoveryAnswer !== ''"
                :error="isWrongRecoveryAnswer ? 'The recovery answer must be at least 4 characters.' : ''"
                :placeholder="placeholders.recoveryAnswer" />
            </BaseFormGroup>

            <div :class="$style.divButton">
              <BaseButton :class="$style.button" :disabled="!canPressChangeSecurityQuestionButton" type="submit">
                <BaseIcon v-if="loadingChangeSecurityQuestion" name="spinner" spin />
                <span v-else>Change Security Question/Answer</span>
              </BaseButton>
            </div>
          </form>
        </div>
      </div>

      <div v-if="showNotificationsSection">
        <div class="row">
          <div class="col-md-12">
            <hr :class="$style.hr" />
          </div>
        </div>

        <div class="mt-40">
          <BaseTitle :class="$style.title">Notifications</BaseTitle>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <form class="px-0" @submit.prevent="submitSaveNotificationsForm">
              <BaseCheckbox
                v-model="emailNotificationReferral"
                class="mt-30 mb-40"
                label="Deal-level referral email notifications"
                :input-value="'1'" />

              <div :class="$style.divButton">
                <BaseButton :class="$style.button" :disabled="!canPressSaveNotificationsButton" type="submit">
                  <BaseIcon v-if="loadingSaveNotifications" name="spinner" spin />
                  <span v-else>Save Preferences</span>
                </BaseButton>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.viewContainer {
  @media (max-width: $lg-breakpoint) {
    width: auto;
    min-width: unset;
  }

  width: auto;
}

.hr {
  margin-top: 56px;
  margin-bottom: 48px;
  border-color: $lightest-gray;
}

.title {
  margin-bottom: 32px;
  color: $primary-blue;
}

.h3 {
  margin-bottom: 32px;
  color: $primary-blue;
}

.divButton {
  width: 100%;
}

.button {
  width: inherit;
  margin-top: 16px;
}

.showMobile {
  display: none;
}

@media (max-width: $lg-breakpoint) {
  .hr {
    margin-top: 36px;
    margin-bottom: 28px;
  }

  .title {
    margin-bottom: 24px;
    color: $primary-charcoal;
  }

  .h3 {
    margin-bottom: 24px;
    color: $primary-charcoal;
  }

  .divButton {
    text-align: center;
  }

  .button {
    width: 269px;
    height: 40px;
  }

  .showMobile {
    display: block;
  }
}
</style>
